"use client";

import Button from "@/components/ui/Button";
import {
  BULK_LISTING_MAX_ITEMS,
  BULK_LISTING_MIN_ITEMS,
} from "@/lib/listing/bulkListingTypes";

export interface ItemNavigationControlsProps {
  currentIndex: number;
  totalItems: number;
  onPrevious: () => void;
  onNext: () => void;
  onAddItem: () => void;
  onRemoveItem: () => void;
  onDuplicateItem: () => void;
  disableRemove?: boolean;
}

export default function ItemNavigationControls({
  currentIndex,
  totalItems,
  onPrevious,
  onNext,
  onAddItem,
  onRemoveItem,
  onDuplicateItem,
  disableRemove = false,
}: ItemNavigationControlsProps) {
  const atMax = totalItems >= BULK_LISTING_MAX_ITEMS;
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          variant="secondary"
          onClick={onPrevious}
          disabled={currentIndex <= 0}
        >
          Previous
        </Button>
        <Button
          type="button"
          variant="secondary"
          onClick={onNext}
          disabled={currentIndex >= totalItems - 1}
        >
          Next
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          variant="secondary"
          onClick={onAddItem}
          disabled={atMax}
          title={
            atMax
              ? `Maximum ${BULK_LISTING_MAX_ITEMS} items`
              : "Add another item"
          }
        >
          Add item
        </Button>
        <Button
          type="button"
          variant="secondary"
          onClick={onDuplicateItem}
          disabled={atMax}
          title="Copies title, price, category, and text fields — not photos"
        >
          Duplicate item
        </Button>
        <Button
          type="button"
          variant="secondary"
          onClick={onRemoveItem}
          disabled={disableRemove || totalItems <= BULK_LISTING_MIN_ITEMS}
        >
          Remove item
        </Button>
      </div>
    </div>
  );
}
